// Purchase-limit helpers shared by product-form.js, cart.js and cart-drawer.js.
//
// A product's per-order limit comes from its tags: 'limit1' -> 1 (legacy), 'limit:N' -> N (1..10).
// The limit applies to the product as a whole (all variants/sizes combined).
// Keep in sync with snippets/product-limit.liquid and the checkout validation function in
// apps/checkout-rules/extensions/purchase-limit, which is the hard, server-side enforcement.

const PURCHASE_LIMIT_MAX = 10;

function parsePurchaseLimit(tags) {
  let limit = 0;
  (tags || []).forEach((raw) => {
    const tag = String(raw).trim().toLowerCase();
    const match = tag === 'limit1' ? ['limit1', '1'] : tag.match(/^limit:(\d{1,2})$/);
    if (!match) return;
    const n = parseInt(match[1], 10);
    if (n >= 1 && n <= PURCHASE_LIMIT_MAX && (limit === 0 || n < limit)) limit = n;
  });
  return limit;
}

// #cart-data is re-rendered together with the drawer on every cart mutation, so always read it fresh.
function readCartData() {
  const script = document.getElementById('cart-data');
  if (!script) return { items: [] };
  try {
    return JSON.parse(script.textContent);
  } catch (e) {
    return { items: [] };
  }
}

// Quantity of a product already in the cart across all of its variants.
// Pass excludeKey to leave one line item (by its cart `key`) out of the sum.
function productQuantityInCart(cart, productId, excludeKey) {
  return (cart.items || []).reduce((sum, item) => {
    if (item.product_id !== productId) return sum;
    if (excludeKey && item.key === excludeKey) return sum;
    return sum + item.quantity;
  }, 0);
}

function purchaseLimitMessage(limit) {
  return window.cartStrings.limitError.replace('[limit]', limit);
}
